<style scoped>
    .container{
        position: relative;
    }
    .group-header, .group-footer{
        padding: 6px 10px;
        font-weight: bold;
    }
    .ivu-form-item{
        margin-bottom: 5px;
    }
    .select-expense-type-btn{
        white-space: pre-line;
    }
</style>
<template>
    <div class="container">
        <div class="line text-bold">
            <span>冲销历史</span>
<!--            <Button size="small" type="primary" icon="md-add" @click="editGroup(new_group)">添加</Button>-->
        </div>
        <div class="hr"></div>
        <div class="line" v-show="expense_write_off_groups.length">
            <div class="line" v-for="group in expense_write_off_groups" :key="group.id">
                <Table size="small" :columns="item_columns" :data="group.expense_write_off_items">
                    <div class="group-header" slot="header">
                        <span>[ {{group.write_off_date}} ] {{group.uid || '-'}}</span>
                        <span>{{group.name}}</span>
                        <Button size="small" @click="editGroup(group)" icon="md-create">编辑</Button>
                    </div>
                    <div class="line"></div>
                    <div class="group-footer" slot="footer">
                        <span>合计金额: {{groupTotalPrice(group)}}</span>
                    </div>
                </Table>
                <div class="hr"></div>
            </div>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>

        <div class="line" v-show="page_info.total">
            <Page
                show-total
                show-elevator
                :current="page_info.current"
                :total="page_info.total"
                :page-size="page_info.page_size"
                @on-change="pageChange">
            </Page>
        </div>

        <Modal
            v-model="edit_config.modal"
            width='800'
            title="添加 / 编辑"
            ok-text="保存"
            :loading="edit_config.loading"
            :mask-closable="false"
            @on-ok="editOK">
            <Form :label-width="70">
                <FormItem label="冲销日期">
                    <DatePicker type="date" :value="edit_group.write_off_date" @on-change="dateChange" placeholder="选择日期" style="width: 183px"></DatePicker>
                </FormItem>
                <Row :gutter="4">
                    <i-col span="8">
                        <FormItem label="申请人">
                            <CustomerSelector v-model="edit_group.apply_user_id" @on-change="setApplyUser">
                                <div style="width: 151px">
                                    <span v-if="edit_group.apply_user_id">{{edit_group.apply_user}}</span>
                                    <span class="color-grey" v-else>选择</span>
                                </div>
                            </CustomerSelector>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="公司">
                            <Select v-model="edit_group.company_id">
                                <Option :value="0">选择公司</Option>
                                <Option v-for="company in companies" :value="company.id" :key="company.id">{{company.short_name}}</Option>
                            </Select>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="团队">
                            <Select v-model="edit_group.team_id" placeholder="选择团队">
                                <Option :value="0">选择团队</Option>
                                <Option :value="team.id" v-for="team in teams" :key="team.id" v-if="!team.del">{{team.name}}</Option>
                            </Select>
                        </FormItem>
                    </i-col>
                </Row>
                <Row :gutter="4">
                    <i-col span="8">
                        <FormItem label="发票类型">
                            <Select v-model="edit_group.invoice_type">
                                <Option :value="type.value" v-for="type in invoice_types" :key="type.value">{{type.name}}</Option>
                            </Select>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="发票税率">
                            <Select v-model="edit_group.tax_rate">
                                <Option value="0.0">0%</Option>
                                <Option value="0.03">3%</Option>
                                <Option value="0.05">5%</Option>
                                <Option value="0.06">6%</Option>
                                <Option value="0.10">10%</Option>
                                <Option value="0.16">16%</Option>
                            </Select>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="实际税额">
                            <i-input v-model="edit_group.tax"></i-input>
                        </FormItem>
                    </i-col>
                </Row>
                <FormItem label="备注">
                    <i-input type="textarea" :maxlength="500" v-model="edit_group.name" placeholder="备注..."></i-input>
                </FormItem>
            </Form>
            <div class="line">
                <table class="mis-table">
                    <thead>
                    <tr>
                        <th>冲销名称</th>
                        <th>团队</th>
                        <th>金额</th>
                        <th>费用类别</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in edit_group.expense_write_off_items" :key="index">
                        <td>
                            <i-input size="small" v-model="item.name" placeholder="冲销名称..."></i-input>
                        </td>
                        <td width="120">
                            <Select size="small" v-model="item.team_id" placeholder="选择团队">
                                <Option :value="0">请选择团队</Option>
                                <Option :value="team.id" v-for="team in teams" :key="team.id" v-if="!team.del">{{team.name}}</Option>
                            </Select>
                        </td>
                        <td width="120">
                            <i-input class="text-right" size="small" v-model="item.price"></i-input>
                        </td>
                        <td>
                            <span>{{getExpenseTypeName(item.expense_type_id)}}</span>
                            <Poptip placement="bottom" transfer width="300">
                                <span class="color-info text-underline pointer">选择</span>
                                <div class="pop-tip-content" slot="content">
                                    <i-input v-model="search_expense_type_text" placeholder="请输入费用类别关键字...">
                                        <span slot="prepend">搜索</span>
                                    </i-input>
                                    <div class="line">
                                        <Button class="select-expense-type-btn" size="small" long style="margin-bottom: 3px"
                                             v-for="type in search_expense_type_result"
                                             @click="setExpenseType(item, type)"
                                             :key="type.id">
                                            <span>{{type.name}}</span>
                                        </Button>
                                    </div>
                                </div>
                            </Poptip>
                        </td>
                        <td>
                            <Button size="small" shape="circle" icon="md-add" @click="addItem" v-if="index === edit_group.expense_write_off_items.length - 1"></Button>
                            <Button size="small" shape="circle" icon="md-close" @click="delItem(item, index)" v-if="index > 0"></Button>
                            <Tooltip content="复制" placement="top">
                                <Button size="small" shape="circle" icon="ios-copy" @click="copyItem(item)"></Button>
                            </Tooltip>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </Modal>
    </div>
</template>
<script>
    import CustomerSelector from '../../components/customer/selector';
    import InvoiceUtil from '../../invoice/libs/util';
    import fin_base from '../mixins/fin_base';
    export default {
        mixins: [fin_base],
        components: { CustomerSelector },
        props: {
            payee_company: {
                type: Object
            },
            inherit_expense_types: {
                type: Array
            },
            inherit_expense_type_hash: {
                type: Object
            }
        },
        data(){
            return {
                params: {
                    id: this.payee_company.id,
                    page: 1,
                    per_page: 3
                },
                loading: false,
                expense_types: this.inherit_expense_types,
                expense_type_hash: this.inherit_expense_type_hash,
                expense_write_off_groups: [],
                new_item: {
                    expense_write_off_group_id: 0,
                    name: '',
                    expense_type_id: 0,
                    team_id: 0,
                    price: 0
                },
                edit_group: {expense_write_off_items:[]},
                edit_config: {
                    modal: false,
                    loading: true
                },
                page_info: {
                    current: 1,
                    total: 0,
                    page_size: 10
                },
                invoice_types: InvoiceUtil.invoice_types,
                item_columns: [
                    {
                        title: '冲销名称',
                        key: 'name',
                        align: 'center'
                    },
                    {
                        title: '团队',
                        key: 'team',
                        align: 'center',
                        render: (h, params)=>{
                            return h('span', this.getTeamNameById(params.row.team_id));
                        }
                    },
                    {
                        title: '金额',
                        key: 'price',
                        align: 'center',
                        render: (h, params)=>{
                            return h('span', Util.formatPrice(params.row.price));
                        }
                    },
                    {
                        title: '费用类别',
                        key: 'expense_type',
                        align: 'center',
                        render: (h, params)=>{
                            return h('span', this.getExpenseTypeName(params.row.expense_type_id));
                        }
                    }
                ]
            }
        },
        computed: {
            new_group(){
                return {
                    payee_company_id: this.payee_company.id,
                    write_off_date: '',
                    name: '',
                    company_id: 0,
                    team_id: 0,
                    apply_user_id: 0,
                    apply_user: '',
                    invoice_type: -1,
                    tax: 0.00,
                    tax_rate: 0.00,
                    expense_write_off_items: [Util.clone(this.new_item)]
                }
            }
        },
        created(){
            this.init();
        },
        mounted(){
            //
        },
        methods: {
            init(){
                if(this.expense_write_off_groups.length === 0){
                    this.getGroups();
                }
            },
            pageChange(page){
                this.params.page = page;
                this.getGroups();
            },
            getGroups(){
                this.loading = true;
                this.expense_write_off_groups = [];
                Util.ajax.get(Util.api.query_expense_write_off_groups, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    if(res.code === 1){
                        let data = res.data;
                        data.expense_write_off_groups.forEach((group)=>{
                            this.expense_write_off_groups.push(group);
                        });
                        this.page_info.current = data.cur_page;
                        this.page_info.page_size = data.per_page;
                        this.page_info.total = data.total_count;
                    }else{
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.loading = false;
                    this.$Modal.error({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            editGroup(group){
                this.edit_group = Util.clone(group);
                this.edit_config.modal = true;
            },
            dateChange(date){
                this.edit_group.write_off_date = date;
            },
            setApplyUser(customer){
                this.edit_group.apply_user = customer.account;
            },
            checkValid(){
                let err_msg = '';
                if(!this.edit_group.write_off_date){
                    err_msg += '<p>请选择[日期]</p>';
                }
                if(!this.edit_group.apply_user_id){
                    err_msg += '<p>请选择[申请人]</p>';
                }
                if(!this.edit_group.company_id){
                    err_msg += '<p>请选择[公司]</p>';
                }
                if(!this.edit_group.team_id){
                    err_msg += '<p>请选择[团队]</p>';
                }
                if(this.edit_group.invoice_type === -1){
                    err_msg += '<p>请选择[发票类型]</p>';
                }
                if(!Util.isNumber(this.edit_group.tax)){
                    err_msg += '<p>请填写正确的[税额]</p>';
                }
                this.edit_group.expense_write_off_items.forEach((item, index)=>{
                    if(!item.name.trim()){
                        err_msg += `<p>冲销${index+1}, 请填写[名称]</p>`;
                    }
                    if(!item.team_id){
                        err_msg += `<p>冲销${index+1}, 请选择[团队]</p>`;
                    }
                    if(!item.expense_type_id){
                        err_msg += `<p>冲销${index+1}, 请选择[费用类别]</p>`;
                    }
                    if(!Util.isNumber(item.price)){
                        err_msg += `<p>冲销${index+1}, 请填写正确的[金额]</p>`;
                    }
                });
                if(err_msg){
                    this.$Modal.error({
                        title: '错误提示',
                        content: err_msg
                    });
                    this.resetEditLoading();
                    return false;
                }
                return true;
            },
            editOK(){
                if(!this.checkValid()){
                    return;
                }
                Util.ajax.post(Util.api.update_expense_write_off_group, this.edit_group).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        let data = res.data;
                        Util.insertOrUpdateArrayItem(this.expense_write_off_groups, data.group, true);
                        this.payee_company.write_off_sum = data.write_off_sum;
                        this.edit_config.modal = false;
                    }else{
                        this.resetEditLoading();
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.resetEditLoading();
                    this.$Modal.error({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            resetEditLoading(){
                this.edit_config.loading = false;
                setTimeout(()=>{
                    this.edit_config.loading = true;
                }, 500);
            },
            addItem(){
                this.edit_group.expense_write_off_items.push(Util.clone(this.new_item));
            },
            delItem(item, index){
                this.$Modal.confirm({
                    title: '提示',
                    content: '你确认要删除吗?',
                    onOk: ()=>{
                        if(item.id){
                            Util.ajax.post(Util.api.delete_expense_write_off_item, {
                                id: item.id
                            }).then((response)=>{
                                return response.data;
                            }).then((res)=>{
                                if(res.code === 1){
                                    this.edit_group.expense_write_off_items.splice(index, 1);
                                    this.$Message.success('删除成功!');
                                }else{
                                    this.$Modal.error({
                                        title: '提示',
                                        content: res.msg
                                    })
                                }
                            }).catch((e)=>{
                                console.log(e);
                                this.$Modal.error({
                                    title: '提示',
                                    content: e.message
                                })
                            });
                        }else{
                            this.edit_group.expense_write_off_items.splice(index, 1);
                            this.$Message.success('删除成功!');
                        }
                    }
                });
            },
            copyItem(item){
                let new_item = Util.clone(this.new_item);
                new_item.name = item.name;
                new_item.expense_type_id = item.expense_type_id;
                this.edit_group.expense_write_off_items.push(new_item);
            },
            groupTotalPrice(group){
                let total = 0;
                group.expense_write_off_items.forEach((item)=>{
                    total = math.eval(`${total} + ${item.price}`);
                });
                return Util.formatPrice(total.toFixed(2));
            }
        }
    }
</script>
